import { ref, onMounted } from 'vue';
import { useI18n } from 'vue-i18n'

import { Form, message } from 'ant-design-vue';

import Utils from '@/api/Utils';

import { showErrorMessage } from '@/components/common/errorMessage';


export function useRoverForm(formState, rulesRef, roverIdRef, apiCall, mountedHandler) {
    const { t } = useI18n();
    const { validate, validateInfos } = Form.useForm(formState, rulesRef);
    const isLoading = ref(false);
    const isSubmitting = ref(false);
    if (mountedHandler != null && typeof mountedHandler === 'function') {
        onMounted(() => {
            isLoading.value = true;
            mountedHandler();
        });
    }
    const onSubmit = () => {
        validate().then(() => {
            isSubmitting.value = true;
            const data = {
                ...Utils.toObject(formState),
                id: roverIdRef.value,
            }
            apiCall(
                data,
                () => {
                    isSubmitting.value = false;
                    message.success(t('rover-page.messages.success'));
                },
                error => {
                    isSubmitting.value = false;
                    let errors = error.response.data;
                    if (errors) {
                        showErrorMessage(errors);
                    }
                },
            );
        }).catch(() => {
            isSubmitting.value = false;
        });
    };
    return {
        validateInfos,
        isLoading,
        isSubmitting,
        onSubmit,
    }
}
